import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveCid() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((cidId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = cidId
      ? quarkusApi.put(`/cid-catalog/${cidId}`, payload, authHeader)
      : quarkusApi.post('/cid-catalog', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
